<template>
	<div class="big-screen">
		<common-layout>
			<div slot="header">
				<h3>数据大屏</h3>
			</div>
			<div slot="container">
				数据大屏内容
			</div>
		</common-layout>
	</div>
	
</template>

<script>
import CommonLayout from '../components/common-layout.vue'
export default {
   components: { CommonLayout},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
  @include component(big-screen){
	height: 100%;
  }
</style>



